import type { TargetDatabaseName } from "./types"

interface CognitoUserPoolParams {
  identityPoolId: string
  region: string
  userPoolId: string
  userPoolWebClientId: string
}

const AWS_REGION = "us-west-2"

/**
 * NOTE: Cypress imports this so no react native code should be here.
 */
export function getUserPoolCredentials({
  targetDatabaseName,
}: {
  targetDatabaseName: TargetDatabaseName
}): CognitoUserPoolParams {
  switch (targetDatabaseName) {
    case "LOCAL":
    case "DEV": {
      return {
        identityPoolId: "us-west-2:45eab45b-5655-4180-b20a-cda3b78e860d",
        region: AWS_REGION,
        userPoolId: "us-west-2_izfCnYzur",
        userPoolWebClientId: "491c10dvoanpubpcv4jc8rj080",
      }
    }
    case "BETA": {
      return {
        identityPoolId: "us-west-2:377f50ea-27ee-46c1-8aa2-2f3b6d8b7b39",
        region: AWS_REGION,
        userPoolId: "us-west-2_0LE7ruT9v",
        userPoolWebClientId: "1ngqrgne7j9qk9o71ku7jg00st",
      }
    }
    case "DEMO":
      return {
        identityPoolId: "us-west-2:377f50ea-27ee-46c1-8aa2-2f3b6d8b7b39",
        region: AWS_REGION,
        userPoolId: "us-west-2_lrIInKWkI",
        userPoolWebClientId: "63i9d51qe5heg5mlbvqa59td13",
      }
    case "PROD": {
      return {
        identityPoolId: "us-west-2:377f50ea-27ee-46c1-8aa2-2f3b6d8b7b39",
        region: AWS_REGION,
        userPoolId: "us-west-2_vY9ky781T",
        userPoolWebClientId: "nl7di6o994hgsuuilc3qiuire",
      }
    }
    default: {
      throw new TypeError(
        `Unknown targetDatabaseName: ${JSON.stringify(targetDatabaseName)}`,
      )
    }
  }
}
